import { artPhoneBook } from '@assets/png/imagesPng';
import LocalImage from '@atoms/LocalImage';
import { Text, View } from '@components/primitives';
import PinWithAddPhone from '@molecules/PinWithAddPhone';
import appStyles from '@root/appStyles';
import { addPhoneTemplate1 } from '@root/constants';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, ImageStyle } from 'react-native';
import styles from './styles';

interface PhoneEmptyViewProps {
  isTransact?: boolean;
  transactionCategoryId?: string;
}

const PhoneEmptyView = ({ isTransact = false, transactionCategoryId = '' }: PhoneEmptyViewProps) => {
  const { t } = useTranslation('common');

  return (
    <View style={appStyles.marginTop(16)}>
      <LocalImage
        source={artPhoneBook}
        width={100}
        height={50}
        style={styles.phoneBookStyles as StyleProp<ImageStyle>}
        accessibilityIgnoresInvertColors
      />
      <Text variant="lg-bold" textAlign="center" style={appStyles.marginTop(8)}>
        {t('phoneTransfer.noRegisteredText')}
      </Text>
      <Text variant="md-normal" color={colors.neutral.darkMist} textAlign="center" style={appStyles.marginTop(4)}>
        {t('phoneTransfer.phoneAddPurpose')}
      </Text>
      <PinWithAddPhone type={addPhoneTemplate1} isTransact={isTransact} transactionCategoryId={transactionCategoryId} />
    </View>
  );
};

export default PhoneEmptyView;
